class CeCategoryNavHover {
  constructor() {
    this.menuBar = document.querySelector('.ce-header__menu-bar');
    this.nav = document.querySelector('.ce-category-nav--desktop');
    if (!this.nav || !this.menuBar) return;

    this.items = Array.from(this.nav.querySelectorAll('.ce-category-nav__item'));
    this.closeDelay = 50;
    this.closeTimeout = null;
    this.activeDetails = null;
    this.abortController = new AbortController();

    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    this.bind();
  }

  bind() {
    const { signal } = this.abortController;

    this.items.forEach((item) => {
      const details = item.querySelector('.ce-mega-menu');
      if (!details) return;

      item.addEventListener('mouseenter', () => this.onItemEnter(details), { signal });
      item.addEventListener('mouseleave', (event) => this.onItemLeave(event, details), { signal });

      const parentLink = details.querySelector('.ce-category-nav__parent-link');
      if (parentLink) {
        parentLink.addEventListener(
          'click',
          (event) => {
            event.stopPropagation();
          },
          { signal }
        );
      }
    });

    this.nav.querySelectorAll('.ce-mega-menu__content').forEach((panel) => {
      panel.addEventListener('mouseenter', () => this.clearCloseTimeout(), { signal });
    });

    this.menuBar.addEventListener('mouseleave', () => this.scheduleCloseAll(), { signal });
    this.menuBar.addEventListener('mouseenter', () => this.clearCloseTimeout(), { signal });
  }

  onItemEnter(details) {
    this.clearCloseTimeout();
    this.closeAllExcept(details);
    this.open(details);
  }

  onItemLeave(event, details) {
    const related = event.relatedTarget;
    if (related?.closest?.('.ce-category-nav__item, .ce-mega-menu__content')) return;

    this.scheduleClose(details);
  }

  scheduleClose(details) {
    this.clearCloseTimeout();
    this.closeTimeout = window.setTimeout(() => {
      this.close(details);
    }, this.closeDelay);
  }

  scheduleCloseAll() {
    this.clearCloseTimeout();
    this.closeTimeout = window.setTimeout(() => this.closeAll(), this.closeDelay);
  }

  clearCloseTimeout() {
    if (!this.closeTimeout) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  open(details) {
    details.setAttribute('open', '');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    this.activeDetails = details;
  }

  close(details) {
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    if (this.activeDetails === details) this.activeDetails = null;
  }

  closeAllExcept(activeDetails) {
    this.items.forEach((item) => {
      const details = item.querySelector('.ce-mega-menu');
      if (details && details !== activeDetails) this.close(details);
    });
  }

  closeAll() {
    this.items.forEach((item) => {
      const details = item.querySelector('.ce-mega-menu');
      if (details) this.close(details);
    });
    this.activeDetails = null;
  }

  destroy() {
    this.abortController.abort();
    this.clearCloseTimeout();
    this.closeAll();
  }
}

let ceCategoryNavHover;

function initCeCategoryNavHover() {
  ceCategoryNavHover?.destroy();
  ceCategoryNavHover = new CeCategoryNavHover();
}

document.addEventListener('DOMContentLoaded', initCeCategoryNavHover);
document.addEventListener('shopify:section:load', initCeCategoryNavHover);
